<template>
  <div class="layout-wrapper layout-content-navbar">
    <div class="layout-container" v-if="loggedIn">
      <!-- Menu -->

      <aside id="layout-menu" class="layout-menu active menu-vertical menu bg-menu-theme">
        <div class="app-brand demo">
          <router-link class="app-brand-link" to="/">
            <img  class="app-brand-logo demo" width="190" alt="Logo de Sofofa Gris" src="../assets/LogoSofofaGris.jpg"/>
          </router-link>
          <a href="javascript:void(0);" v-on:click="openSideBar" class="layout-menu-toggle menu-link text-large ms-auto">
            <i class="bx bx-chevron-left bx-sm align-middle"></i>
          </a>
        </div>

        <div class="menu-inner-shadow"></div>

        <ul class="menu-inner py-1" v-if="menus.length > 0">
          <!-- Page -->
          <template v-for="menu in menus" :key="menu.id">
            <li  v-if="validRole(menu.roles)" class="menu-item" :class="{active: this.$route.path === menu.to}" >
            <router-link :to="menu.to" class="menu-link" v-if="menu.children === false">
              <i :class="menu.icon"></i>
              <div data-i18n="Email">{{menu.name}}</div>
            </router-link>
            <template v-else>
              <a href="javascript:void(0);" class="menu-link menu-toggle">
                <i :class="menu.icon"></i>
                <div data-i18n="Layouts">{{menu.name}}</div>
              </a>
              <ul class="menu-sub">
                <li class="menu-item" v-for="submenu in menu.children" :key="submenu.id">
                  <router-link :to="submenu.to" class="menu-link">
                    <div data-i18n="Email">{{submenu.name}}</div>
                  </router-link>
                </li>
              </ul>
            </template>
          </li>
          </template>
        </ul>

        <div class="text-center">
          <strong>{{versions.local}}</strong>
        </div>

      </aside>
      <!-- / Menu -->

      <!-- Layout container -->
      <div class="layout-page">
        <!-- Navbar -->

        <nav
            class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
            id="layout-navbar"
        >
          <div class="layout-menu-toggle navbar-nav d-xl-none align-items-xl-center me-3 me-xl-0">
            <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)" v-on:click="openSideBar">
              <i class="bx bx-menu bx-sm"></i>
            </a>
          </div>

          <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
            <ul class="navbar-nav flex-row align-items-center ms-auto">
              <!-- User -->
              <li class="nav-item navbar-dropdown dropdown-user dropdown">
                <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                  <div class="avatar avatar-online">
                    <img src="../assets/img/avatars/notfound.png" alt class="w-px-40 h-auto rounded-circle" />
                  </div>
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item" href="#">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar avatar-online">
                            <img src="../assets/img/avatars/notfound.png" alt class="w-px-40 h-auto rounded-circle" />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <span class="d-block fw-semibold">{{currentUser.name}}</span>
                          <small class="text-muted">{{currentUser.role.name}}</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <div class="dropdown-divider"></div>
                  </li>
                  <li>
                    <router-link to="/profile" class="dropdown-item" href="#">
                      <i class="bx bx-user me-2"></i>
                      <span class="align-middle">Mi Perfil</span>
                    </router-link>
                  </li>
                  <li>
                    <div class="dropdown-divider"></div>
                  </li>
                  <li>
                    <button v-on:click="logout" class="dropdown-item" href="#">
                      <i class="bx bx-power-off me-2"></i>
                      <span class="align-middle">Salir</span>
                    </button>
                  </li>
                </ul>
              </li>
              <!--/ User -->
            </ul>
          </div>
        </nav>

        <!-- / Navbar -->

        <!-- Content wrapper -->
        <div class="content-wrapper">
          <!-- Content -->
          <slot />
          <!-- / Content -->

          <!-- Footer -->
          <footer class="content-footer footer bg-footer-theme">
            <div class="container-xxl d-flex flex-column flex-md-row flex-wrap justify-content-between py-2">
              <div class="mb-2 mb-md-0">
                ©
                2022
                , hecho️ por
                <a href="https://muss.cl" target="_blank" class="footer-link fw-bolder">Muss SPA</a>
              </div>
            </div>
          </footer>
          <!-- / Footer -->

          <div class="content-backdrop fade"></div>
        </div>
        <!-- Content wrapper -->
      </div>
      <!-- / Layout page -->
    </div>

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle"></div>

    <!-- Drag Target Area To SlideIn Menu On Small Screens -->
    <div class="drag-target"></div>
  </div>
</template>
<script>
import {Helpers} from "./helpers"
import {Menu} from "./menu"
export default {
  name: 'AppLayoutPrivate',
  setup() {

  },
  data : function () {
    return {
      openSide: false,
      menus: [
        {
          "id": 1,
          "name": "Dashboard",
          "to": "/",
          "icon": "menu-icon tf-icons bx bx-home-circle",
          "active": true,
          "roles": ["encargado","superadmin","informante"],
          "children": false
        },
        {
          "id": 2,
          "name": "Avances",
          "to": "/progress",
          "roles": ["encargado","superadmin"],
          "icon": "menu-icon tf-icons bx bx-chalkboard",
          "active": true,
          "children": false
        },
        {
          "id": 2,
          "name": "Benchmark",
          "to": "/benchmark",
          "roles": ["encargado","superadmin"],
          "icon": "menu-icon tf-icons bx bx-bar-chart-square",
          "active": true,
          "children": false
        },
        {
          "id": 4,
          "name": "Usuarios",
          "to": "/users",
          "roles": ["encargado","superadmin"],
          "icon": "menu-icon tf-icons bx bx-user",
          "active": true,
          "children": false
        },
        {
          "id": 5,
          "name": "Administración",
          "to": "/admin",
          "roles": ["superadmin"],
          "icon": "menu-icon tf-icons bx bx-archive-in",
          "active": true,
          "children": [
            {
              "id": 1,
              "name": "Dashboard",
              "to": "/admin",
              "icon": "menu-icon tf-icons bx bx-home-circle",
              "active": true,
              "roles": ["superadmin"],
              "children": false
            },
            {
              "id": 8,
              "name": "Usuarios",
              "to": "/admin/users",
              "roles": ["superadmin"],
              "icon": "menu-icon tf-icons bx bx-user",
              "active": true,
              "children": false
            },
            {
              "id": 6,
              "name": "Dimensiones",
              "roles": ["superadmin"],
              "to": "/admin/dimensions",
              "icon": "menu-icon tf-icons bx bx-archive-in",
              "active": true,
            },
            {
              "id": 7,
              "name": "Empresas",
              "to": "/companies",
              "roles": ["superadmin"],
              "icon": "menu-icon tf-icons bx bx-detail",
              "active": true,
            },
            {
              "id": 8,
              "name": "Periodos",
              "to": "/admin/periods",
              "roles": ["superadmin"],
              "icon": "menu-icon tf-icons bx bx-detail",
              "active": true,
            }
          ]
        }
      ]
    }
  },
  props : [
    'uuid','versions'
  ],
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      return this.currentUser && this.currentUser.role.id === 'superadmin';
    },
    showEncargado() {
      return this.currentUser && this.currentUser.role.id === 'encargado';
    }
  },
  created() {
    if (!this.loggedIn) {
      this.$router.push("/auth/login");
    }
  },
  mounted() {
    Helpers.init();

    if (Helpers.isMobileDevice() && window.chrome) {
      document.documentElement.classList.add('layout-menu-100vh')
    }

    // Update layout after page load
    if (document.readyState === 'complete') Helpers.update()
    else {
      document.addEventListener('DOMContentLoaded', function onContentLoaded() {
        Helpers.update()
        document.removeEventListener('DOMContentLoaded', onContentLoaded)
      })
    }

    new Menu(document.getElementById('layout-menu'), {
      orientation: 'vertical',
      closeChildren: false
    });
  },
  methods : {
    openSideBar(){
      let classSet = "layout-menu-expanded";
      if (!this.isSmallScreen()) {
        classSet = 'layout-menu-collapsed';
      }
      if(this.openSide){
        document.querySelector('html').classList.remove(classSet);
        this.openSide = false;
      } else {
        document.querySelector('html').classList.add(classSet);
        this.openSide = true;
      }
    },
    isSmallScreen() {
      return (
          (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 1200
      )
    },
    logout() {
      this.$store.dispatch("auth/logout").then(
          () => {
            this.$router.push("/auth/login");
          },
          (error) => {
            this.loading = false;
            this.message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
          }
      );
    },
    validRole(roles){
        if(roles === undefined){
          return false;
        } else return !!(this.currentUser && this.currentUser.role && roles.includes(this.currentUser.role.id));
    }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.spinner {
  margin: auto;
}

.vld-parent {
  position: relative;
}

#overlay {
  background-color: rgba(0,0,0,0.3);
  border: 0 solid #d9dee3;
  border-radius: 0.5rem;
  z-index: 2;
  cursor: pointer;
  min-height: 400px;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
